export default __webpack_public_path__ + "static/media/chevron-down.a3a9a58b.svg";